module.exports = __webpack_public_path__ + "static/media/calque7.7d7e27ff.png";